var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Reception(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v18H15V46h46zm-33.35-3.62a2 2 0 001.35-2V28a1 1 0 011-1h2v16h12V27h2a1 1 0 011 1v12.4a2 2 0 002.292 2.087A2 2 0 0051 40.49V28a5 5 0 00-5-5H30a5 5 0 00-5 5v12.49a1.999 1.999 0 002.65 1.89zM41.12 19.9a5 5 0 10-6.193-7.85 5 5 0 006.193 7.85z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Reception.e0571314.svg";
export { SvgE4Reception as ReactComponent };